import * as z from 'zod';

// Schema for employee form validation
export const employeeFormSchema = z.object({
  id: z.number().optional(),
  empUserId: z.string().optional(),
  empName: z.string().min(5, 'Name must be at least 5 characters'),
  empEmail: z.string().email('Invalid email address'),
  empPhone: z.string().regex(/^\d{10}$/, 'Phone number must be exactly 10 digits'),
  empAvatar: z.string().optional(),
  empCommission: z
    .number({ required_error: 'Commission is required' })
    .min(1, 'Must be at least 1') // Min value
    .max(100, 'Must be at most 100') // Max value
    .default(55), // Default value
  empCheckPercent: z
    .number({ required_error: 'Check percent is required' })
    .min(1, 'Must be at least 1') // Min value
    .max(100, 'Must be at most 100') // Max value
    .default(60), // Default value
  empCategory: z.array(z.string()).min(1, 'At least one category is required'),
  empSpecialCategory: z.array(z.string()).default([]),
  empRole: z.array(z.string()).min(1, 'At least one role is required'),
  empStatus: z.boolean().default(true),
});

export type EmployeeFormValues = z.infer<typeof employeeFormSchema>;
